import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade médico). */
export type CertidaoCadastralMedicoJob = ReportJob;
export type CertidaoCadastralMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão Cadastral (Médico). */
@Injectable({ providedIn: 'root' })
export class CertidaoCadastralMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-cadastral-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.certidaoCadastralMedico;
}
